import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { Button, Modal, InputGroup, FormControl } from 'react-bootstrap'

import locationApi from '../../utils/locationApi'
import config from '../../config'

const url = config.api.baseUrl + '/branches'

const EditBranchModal = (props) => {
  const { data, onClose } = props

  const [confirmDelete, setConfirmDelete] = useState(false)

  const handleSubmit = useCallback(
    async (data) => {
      try {
        await locationApi('post', url, data)
        onClose()
        toast('Succesfully updated.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
      } catch (err) {
        onClose()
        toast.error(`${err}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
        console.log(err)
      }
    }, [onClose])

  const handleDelete = useCallback(async (event) => {
    event.preventDefault()

    if (confirmDelete) {
      const newUrl = url + `/${data.name}`
      try {
        await locationApi('delete', newUrl)
        onClose()
        toast('Succesfully Deleted.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
      } catch (err) {
        onClose()
        toast.error(` ${err}`, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2500
        })
        console.log(err)
      }
    } else {
      setConfirmDelete(true)
    }
  }, [confirmDelete, data.name, onClose])

  return (
    <>
      <Formik
        initialValues={{
          name: data?.name,
          description: data?.description
        }}
        onSubmit={handleSubmit}
      >{
          ({ values, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Modal show onHide={onClose}>
                <Modal.Header closeButton>
                  <Modal.Title>Branch</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <InputGroup className='mb-3'>
                    <InputGroup.Prepend>
                      <InputGroup.Text>ID</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      name='name'
                      value={values.name}
                      disabled
                    />
                  </InputGroup>
                  <InputGroup className='mb-3'>
                    <InputGroup.Prepend>
                      <InputGroup.Text>Description</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl
                      name='description'
                      value={values.description}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Modal.Body>
                <Modal.Footer>
                  {!confirmDelete
                    ? (
                      <Button variant='danger' onClick={handleDelete}>
                        Delete
                      </Button>
                    )
                    : (
                      <Button variant='danger' onClick={handleDelete}>
                        Click Again to Delete
                      </Button>
                    )}
                  <Button onClick={handleSubmit}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }
      </Formik>
    </>
  )
}

export default EditBranchModal

EditBranchModal.propTypes = {
  data: PropTypes.object,
  onClose: PropTypes.func
}
